import React, { useState, useEffect } from 'react';
import './App.css';
import Tutorial from './Tutorial';

export default function App() {
  const API_URL = 'https://jeevanpath.app/api/v1';
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState('');
  const [ngiScore, setNgiScore] = useState(0);
  const [dailyNGI, setDailyNGI] = useState(0);
  const [weeklyNGI, setWeeklyNGI] = useState(0);
  const [lifetimeNGI, setLifetimeNGI] = useState(0);
  const [growthStage, setGrowthStage] = useState('Seeding');
  const calculateNGIScores = () => {
    const dailyScores = JSON.parse(localStorage.getItem('dailyNGIScores') || '{}');
    
    if (Object.keys(dailyScores).length === 0) {
      setDailyNGI(0);
      setWeeklyNGI(0);
      setLifetimeNGI(0);
      setGrowthStage('Seeding');
      return;
    }

    const today = new Date(selectedDate);
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);

    let weeklyScores = [];
    let todayScore = 0;

    Object.entries(dailyScores).forEach(([date, score]) => {
      if (date === selectedDate) {
        todayScore = score;
      }
      const scoreDate = new Date(date);
      if (scoreDate >= weekAgo) {
        weeklyScores.push(score);
      }
    });

    const newDailyNGI = Math.round(todayScore * 100) / 100 || 0;
    const newWeeklyNGI = weeklyScores.length > 0 ? Math.round((weeklyScores.reduce((a,b) => a+b) / weeklyScores.length) * 100) / 100 : 0;
    
    const newOverallNGI = Math.round(((newDailyNGI + newWeeklyNGI) / 2) * 100) / 100;

    setDailyNGI(newDailyNGI);
    setWeeklyNGI(newWeeklyNGI);
    setLifetimeNGI(newOverallNGI);

    let stage = 'Seeding';
    if (newOverallNGI >= 81) stage = 'Thriving';
    else if (newOverallNGI >= 61) stage = 'Blooming';
    else if (newOverallNGI >= 41) stage = 'Growing';
    else if (newOverallNGI >= 21) stage = 'Sprouting';
    setGrowthStage(stage);
  };
  const [streak, setStreak] = useState(0);
  const [currentScreen, setCurrentScreen] = useState('home');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [todaysHabits, setTodaysHabits] = useState({});
  const [prayers, setPrayers] = useState([]);
  const [prayerText, setPrayerText] = useState('');
  const [selectedMood, setSelectedMood] = useState('Grateful');
  const [earnedBadges, setEarnedBadges] = useState({});
  const [showBadgeModal, setShowBadgeModal] = useState(false);
  const [newBadge, setNewBadge] = useState(null);
  const [bookmarks, setBookmarks] = useState([]);
  const [bibleSearch, setBibleSearch] = useState('');
  const [bibleResults, setBibleResults] = useState([]);
  const [bibleLoading, setBibleLoading] = useState(false);
  const [tutorialActive, setTutorialActive] = useState(false);
  const [tutorialStep, setTutorialStep] = useState(0);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [pendingBookmark, setPendingBookmark] = useState(null);
  const [editingBookmarkId, setEditingBookmarkId] = useState(null);

  const pillars = [
    { name: 'Prayer', emoji: '🙏', key: 'prayer' },
    { name: 'Bible Study', emoji: '📖', key: 'bible' },
    { name: 'Witness', emoji: '✨', key: 'witness' },
    { name: 'Intercession', emoji: '🤝', key: 'intercession' },
    { name: 'Apply Word', emoji: '💪', key: 'apply' },
    { name: 'Church Service', emoji: '🏛️', key: 'church' },
    { name: 'Worship', emoji: '🎵', key: 'worship' },
    { name: 'Serve Others', emoji: '💝', key: 'serve' },
    { name: 'Fellowship', emoji: '💬', key: 'fellowship' },
    { name: 'Study God', emoji: '📚', key: 'study' },
    { name: 'Leadership', emoji: '🎓', key: 'leadership' },
    { name: 'Live Example', emoji: '🌟', key: 'example' }
  ];
const dailyVerses = [
    { ref: 'John 3:16 (KJV)', text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.', devotion: 'God\'s love is unconditional. Believe in Jesus and experience eternal life.' },
    { ref: 'Proverbs 3:5-6 (KJV)', text: 'Trust in the Lord with all thine heart; and lean not unto thine own understanding. In all thy ways acknowledge him, and he shall direct thy paths.', devotion: 'Surrender your worries to God. He will guide your path when you trust Him completely.' },
    { ref: 'Psalm 23:1 (KJV)', text: 'The Lord is my shepherd; I shall not want. He maketh me to lie down in green pastures: he leadeth me beside the still waters.', devotion: 'God cares for you like a shepherd. You lack nothing when you rest in His care.' },
    { ref: 'Matthew 6:33 (KJV)', text: 'But seek ye first the kingdom of God, and his righteousness; and all these things shall be added unto you.', devotion: 'Prioritize God and living righteously. He will provide what you truly need.' },
    { ref: 'Philippians 4:6-7 (KJV)', text: 'Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God.', devotion: 'Bring your concerns to God in prayer. His peace will guard your heart and mind.' },
    { ref: '1 John 1:9 (KJV)', text: 'If we confess our sins, he is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.', devotion: 'God\'s forgiveness is immediate and complete. Confession opens the door to restoration.' },
    { ref: 'Romans 8:28 (KJV)', text: 'And we know that all things work together for good to them that love God, to them who are the called according to his purpose.', devotion: 'Even difficult circumstances work toward your good when you love God. Trust His plans.' },
    { ref: 'James 1:2-3 (KJV)', text: 'My brethren, count it all joy when ye fall into divers temptations; Knowing this, that the trying of your faith worketh patience.', devotion: 'Trials build spiritual strength. View challenges as opportunities to grow stronger in faith.' }
  ];

  const getTodayVerse = () => {
    const dayOfYear = Math.floor((new Date() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
    return dailyVerses[dayOfYear % dailyVerses.length];
  };

  const journeyStages = [
    { stage: "Seeding", emoji: "🌱", min: 0, max: 20, color: "#FF6B6B", desc: "Beginning your journey" },
    { stage: "Sprouting", emoji: "🌿", min: 21, max: 40, color: "#FFA500", desc: "Growth is starting" },
    { stage: "Growing", emoji: "🌾", min: 41, max: 60, color: "#FFD700", desc: "Making progress" },
    { stage: "Blooming", emoji: "🌸", min: 61, max: 80, color: "#00BFD9", desc: "Flourishing now" },
    { stage: "Thriving", emoji: "🌳", min: 81, max: 100, color: "#00E5FF", desc: "Fully established" }
  ];

  const getCurrentStage = () => {
    return journeyStages.find(s => ngiScore >= s.min && ngiScore <= s.max) || journeyStages[0];
  };
const getRank = (totalXP) => {
    if (totalXP >= 2001) return { name: 'Diamond', emoji: '💎', color: '#00E5FF' };
    if (totalXP >= 1201) return { name: 'Platinum', emoji: '💜', color: '#C084FC' };
    if (totalXP >= 701) return { name: 'Gold', emoji: '🥇', color: '#FFD700' };
    if (totalXP >= 301) return { name: 'Silver', emoji: '🥈', color: '#C0C0C0' };
    return { name: 'Bronze', emoji: '🥉', color: '#CD7F32' };
  };

  const getRankThresholds = (totalXP) => {
    const ranks = [
      { name: 'Bronze', min: 0, max: 300 },
      { name: 'Silver', min: 301, max: 700 },
      { name: 'Gold', min: 701, max: 1200 },
      { name: 'Platinum', min: 1201, max: 2000 },
      { name: 'Diamond', min: 2001, max: Infinity }
    ];
    const current = ranks.find(r => totalXP >= r.min && totalXP <= r.max) || ranks[0];
    const next = ranks[ranks.indexOf(current) + 1] || current;
    return { current, next, progress: current.name === next.name ? 100 : ((totalXP - current.min) / (next.max - next.min)) * 100 };
  };

  const calculateTotalXP = () => {
    return prayers.length > 0 ? ngiScore * 4 : 0;
  };

  const getTodaysHabitCount = () => Object.values(todaysHabits).filter(v => v).length;

  const checkForNewBadges = () => {
    const habitsToday = getTodaysHabitCount();
    
    if (habitsToday === 12 && !earnedBadges['Perfect Day']) {
      setEarnedBadges(prev => ({ ...prev, ['Perfect Day']: true }));
      setNewBadge('Perfect Day');
      setShowBadgeModal(true);
      fetch(`${API_URL}/badges`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, badge_name: 'Perfect Day', badge_emoji: '🌟' })
      });
    } else if (habitsToday >= 5 && habitsToday < 12 && !earnedBadges['Momentum Builder']) {
      setEarnedBadges(prev => ({ ...prev, ['Momentum Builder']: true }));
      setNewBadge('Momentum Builder');
      setShowBadgeModal(true);
      fetch(`${API_URL}/badges`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, badge_name: 'Momentum Builder', badge_emoji: '🔥' })
      });
    }
  };


  const badgeCriteria = {
    'Streak Master': { emoji: '🔥', desc: 'Maintain 7-day streak', check: () => streak >= 7 },
    'Word Lover': { emoji: '📖', desc: 'Bookmark 5+ Bible verses', check: () => bookmarks.length >= 5 },
    'Intercessor': { emoji: '🤝', desc: 'Log 10+ prayers', check: () => prayers.length >= 10 },
    'Golden Streak': { emoji: '👑', desc: 'Maintain 30-day streak', check: () => streak >= 30 },
    'Master of All': { emoji: '✨', desc: 'Complete all 12 pillars in one day', check: () => Object.values(todaysHabits).filter(v => v).length === 12 },
    'Perfect Day': { emoji: '🌟', desc: 'Complete all 12 habits in one day', check: () => getTodaysHabitCount() === 12 },
    'Momentum Builder': { emoji: '🔥', desc: 'Complete 5 or more habits in one day', check: () => getTodaysHabitCount() >= 5 }
  };

  useEffect(() => {
    if (isLoggedIn && currentScreen === 'home' && !localStorage.getItem('tutorialCompleted')) {
      setTutorialActive(true);
    }
  }, [isLoggedIn, currentScreen]);

  useEffect(() => {
    const saved = localStorage.getItem('jeevanUser');
    if (saved) {
      const u = JSON.parse(saved);
      setUserId(u.userId);
      setUserName(u.userName);
      setNgiScore(u.ngiScore);
      setStreak(u.streak);
      setIsLoggedIn(true);
      loadUserData(u.userId);
    }
  }, []);

  useEffect(() => {
    setTodaysHabits({});
  }, [selectedDate]);

  const checkAndAwardBadges = () => {
    Object.keys(badgeCriteria).forEach(badgeName => {
      const criteria = badgeCriteria[badgeName];
      if (criteria.check() && !earnedBadges[badgeName]) {
        setEarnedBadges(prev => ({ ...prev, [badgeName]: true }));
        setNewBadge(badgeName);
        setShowBadgeModal(true);
        fetch(`${API_URL}/badges`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userId, badge_name: badgeName, badge_emoji: criteria.emoji })
        });
      }
checkForNewBadges();
    });
  };

  const handleBibleSearch = async (query) => {
    setBibleSearch(query);
    if (!query.trim()) {
      setBibleResults([]);
      return;
    }
    setBibleLoading(true);
    try {
      const response = await fetch(`${API_URL}/bible-search/${encodeURIComponent(query)}`);
      const data = await response.json();
      if (data.error) {
        setBibleResults([]);
      } else if (data.text && data.reference) {
        setBibleResults([{ ref: data.reference, text: data.text }]);
      } else {
        setBibleResults([]);
      }
    } catch (err) {
      console.log('Bible search error:', err);
      setBibleResults([]);
    }
    setBibleLoading(false);
  };

const toggleHabit = (habitKey) => {
  setTodaysHabits(prev => ({ ...prev, [habitKey]: !prev[habitKey] }));
  
  if (!todaysHabits[habitKey]) {
    fetch(`${API_URL}/habits`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, habit_name: habitKey, completed: true, date_logged: selectedDate })
    }).then(res => res.json()).then(data => {
      // UPDATE NGI SCORE IN REAL-TIME
      if (data.lifetimeScore) {
        setNgiScore(data.lifetimeScore);
        
        // Update streak too
        if (data.currentStreak) {
          setStreak(data.currentStreak);
        }
        
        // Update localStorage so it persists
        const savedUser = localStorage.getItem('jeevanUser');
        if (savedUser) {
          const updated = JSON.parse(savedUser);
          updated.ngiScore = data.lifetimeScore;
          updated.streak = data.currentStreak;
          localStorage.setItem('jeevanUser', JSON.stringify(updated));
        }
      }
      
      
      // Calculate and update NGI scores
      const habitsCompleted = Object.values({...todaysHabits, [habitKey]: true}).filter(v => v).length;
      const dailyNGI = Math.round((habitsCompleted / 12) * 100 * 100) / 100;
      let dailyScores = JSON.parse(localStorage.getItem('dailyNGIScores') || '{}');
      dailyScores[selectedDate] = dailyNGI;
      localStorage.setItem('dailyNGIScores', JSON.stringify(dailyScores));
      calculateNGIScores();
      // Handle badge popups
      if (data.newBadges && data.newBadges.length > 0) {
        const badge = data.newBadges[0];
        setNewBadge(badge);
        setShowBadgeModal(true);
        loadUserData(userId);
      }
      
      checkAndAwardBadges();
    });
  } else {
    checkAndAwardBadges();
  }
};

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (data.success && data.user && data.user.id) {
        setUserId(data.user.id);
        setUserName(data.user.first_name || email);
        setIsLoggedIn(true);
        setNgiScore(data.user.ngi_score || 0);
        setStreak(data.user.current_streak || 0);
        localStorage.setItem('jeevanUser', JSON.stringify({
          userId: data.user.id,
          userName: data.user.first_name || email,
          ngiScore: data.user.ngi_score || 0,
          streak: data.user.current_streak || 0
        }));
        loadUserData(data.user.id);
        setErrorMsg('');
      } else {
        setErrorMsg('Login failed: ' + (data.message || 'Unknown error'));
      }
    } catch (err) {
      setErrorMsg('Connection error');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, name })
      });
      const data = await res.json();
      if (data.success && data.user && data.user.id) {
        setUserId(data.user.id);
        setUserName(data.user.first_name || email);
        setIsLoggedIn(true);
        setIsRegistering(false);
      } else {
        setErrorMsg('Registration failed');
      }
    } catch (err) {
      setErrorMsg('Connection error');
    }
  };

  const loadUserData = async (uid) => {
    try {
      const prayersRes = await fetch(`${API_URL}/prayers/${uid}`);
      const prayersData = await prayersRes.json();
      const prayersList = Array.isArray(prayersData) ? prayersData : (prayersData.prayers || prayersData.data || []);
      setPrayers(prayersList);

      const bookmarksRes = await fetch(`${API_URL}/bookmarks/${uid}`);
      const bookmarksData = await bookmarksRes.json();
      const bookmarksList = Array.isArray(bookmarksData) ? bookmarksData : (bookmarksData.bookmarks || bookmarksData.data || []);
      setBookmarks(bookmarksList);

      const badgesRes = await fetch(`${API_URL}/badges/${uid}`);
      const badgesData = await badgesRes.json();
      const badgesList = Array.isArray(badgesData) ? badgesData : (badgesData.badges || badgesData.data || []);
      const earnedMap = {};
      badgesList.forEach(b => earnedMap[b.badge_name] = true);
      setEarnedBadges(earnedMap);
    } catch (err) {
      console.log('Error loading data:', err);
    }
  };

  const savePrayer = async (e) => {
    e.preventDefault();
    if (!prayerText.trim()) return;
    try {
      await fetch(`${API_URL}/prayers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, entry_text: prayerText, mood: selectedMood, tags: '', date_created: new Date().toISOString() })
      });
      setPrayers([...prayers, { id: Date.now(), entry_text: prayerText, mood: selectedMood, tags: '', created_at: new Date().toISOString() }]);
      setPrayerText('');
      setSelectedMood('Grateful');
      checkAndAwardBadges();
    } catch (err) {
      console.log('Error saving prayer:', err);
    }
  };

  const openNotesModal = (verse) => {
    setPendingBookmark(verse);
    setNoteText('');
    setEditingBookmarkId(null);
    setShowNotesModal(true);
  };

  const editNotes = (bookmarkId, currentNote) => {
    const bookmark = bookmarks[bookmarkId];
    setPendingBookmark(bookmark);
    setNoteText(currentNote || '');
    setEditingBookmarkId(bookmarkId);
    setShowNotesModal(true);
  };

  const saveNotes = async () => {
    if (!pendingBookmark) return;
    if (editingBookmarkId !== null) {
      const updatedBookmarks = [...bookmarks];
      updatedBookmarks[editingBookmarkId].notes = noteText;
      setBookmarks(updatedBookmarks);
    } else {
      const newBookmark = {
        id: Date.now(),
        verse_reference: pendingBookmark.ref || pendingBookmark.verse_reference || '',
        verse_text: pendingBookmark.text || pendingBookmark.verse_text || '',
        notes: noteText,
        created_at: new Date().toISOString()
      };
      try {
        await fetch(`${API_URL}/bookmarks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            verse_reference: newBookmark.verse_reference,
            verse_text: newBookmark.verse_text,
            created_at: new Date().toISOString()
          })
        });
        setBookmarks([...bookmarks, newBookmark]);
        checkAndAwardBadges();
      } catch (err) {
        console.log('Error bookmarking:', err);
      }
    }
    setShowNotesModal(false);
    setNoteText('');
    setPendingBookmark(null);
    setEditingBookmarkId(null);
  };

  const deleteBookmark = (bookmarkId) => {
    const updatedBookmarks = bookmarks.filter((_, idx) => idx !== bookmarkId);
    setBookmarks(updatedBookmarks);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserId(null);
    setCurrentScreen('home');
    localStorage.removeItem('jeevanUser');
  };

  const startTutorial = () => {
    setTutorialStep(0);
    setTutorialActive(true);
  };

  const nextTutorialStep = () => {
    if (tutorialStep < 8) {
      setTutorialStep(tutorialStep + 1);
    } else {
      completeTutorial();
    }
  };

  const completeTutorial = () => {
    setTutorialActive(false);
    localStorage.setItem('tutorialCompleted', 'true');
  };

  if (!isLoggedIn) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <div style={{ fontSize: '32px' }}>🙏</div>
              <div className="logo-text">
                <h2>Jeevan Path</h2>
                <p>Spiritual Growth</p>
              </div>
            </div>
          </div>
          {errorMsg && <div className="error-message">{errorMsg}</div>}
          <form onSubmit={isRegistering ? handleRegister : handleLogin} className="login-form">
            {isRegistering && (
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} required />
              </div>
            )}
            <div className="form-group">
              <label>Email</label>
              <input type="email" placeholder="your@email.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" placeholder="••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn-login">{isRegistering ? 'Create Account' : 'Login'}</button>
          </form>
          <div className="login-footer">
            <button className="toggle-mode" onClick={() => setIsRegistering(!isRegistering)}>
              {isRegistering ? 'Already have account? Login' : 'Need account? Register'}
            </button>
            <p className="by-church">By Jeevan Church</p>
          </div>
        </div>
      </div>
    );
  }

  if (currentScreen === 'home') {
    return (
      <div className="app-container">
        <div className="app-header">
          <div className="header-content">
            <div className="header-title">
              <h1>🙏 Jeevan Path</h1>
              <p>Welcome, {userName}!</p>
            </div>
            <button className="btn-logout" onClick={handleLogout}>Logout</button>
          </div>
        </div>
        <div className="app-main">
          <div className="score-section">
            <div className="score-card">
              <div className="score-display">
                <div className="score-circle">
                  <div className="score-number">{ngiScore}</div>
                  <div className="score-max">/ 100</div>
                </div>
                <div className="score-info">
                  <h2 className="score-label">Nearness to God Index</h2>
                  <p className="score-desc">Your spiritual growth score based on daily practices.</p>
                </div>
	<div className="journey-stages">
              <p style={{ fontSize: '12px', fontWeight: '700', color: '#00BFD9', marginBottom: '12px' }}>Your Spiritual Journey:</p>
              <div className="stages-row">
                {journeyStages.map((s) => {
                  const isActive = ngiScore >= s.min && ngiScore <= s.max;
                  return (
                    <div key={s.stage} className={`stage-item ${isActive ? 'active' : 'inactive'}`} title={`${s.stage}: ${s.desc}`}>
                      <div className="stage-emoji" style={{ opacity: isActive ? 1 : 0.3 }}>{s.emoji}</div>
                      <div className="stage-label" style={{ opacity: isActive ? 1 : 0.4, color: isActive ? s.color : '#999' }}>{s.stage}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          <div className="personal-note-card-privacy">
            <div className="note-icon">🔐</div>
            <div className="note-content-privacy">
              <p className="note-title-privacy">Your NGI Score Is Private & Personal</p>
              <p className="note-text-privacy">This score is for YOUR personal growth only. No one tracks it. Not administrators. Your data stays on your device.</p>
            </div>
          </div>
              </div>
            </div>
          </div>
          <div style={{ marginBottom: '20px', padding: '16px', background: 'white', borderRadius: '12px', border: '2px solid #00BFD9' }}>
            <label style={{ fontSize: '12px', fontWeight: '700', color: '#004D5C', marginBottom: '8px', display: 'block' }}>Log for Date:</label>
            <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} style={{ padding: '10px', border: '2px solid #00BFD9', borderRadius: '8px', fontSize: '14px', color: '#004D5C', width: '100%' }} />
          </div>
          <div className="stats-row">
            <div className="stat-card">
              <div className="stat-icon">🔥</div>
              <div className="stat-content">
                <div className="stat-value">{streak}</div>
                <div className="stat-label">Day Streak</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-content">
                <div className="stat-value">{Object.values(todaysHabits).filter(v => v).length}</div>
                <div className="stat-label">Today Complete</div>
              </div>
            </div>
          </div>
          <div className="habits-section">
            <div className="section-header">
              <h2>Log Your Spiritual Habits</h2>
              <p>Click to log, click again to unlog</p>
            </div>
            <div className="habits-grid">
              {pillars.map((pillar) => (
                <button key={pillar.key} className={`habit-button ${todaysHabits[pillar.key] ? 'completed' : ''}`} onClick={() => toggleHabit(pillar.key)}>
                  <span className="habit-emoji">{pillar.emoji}</span>
                  <span className="habit-name">{pillar.name}</span>
                  {todaysHabits[pillar.key] && <span className="habit-check">✓</span>}
                </button>
              ))}
            </div>
          </div>
<div className="daily-mission-section">
            <div className="mission-header">
              <h3>🎯 Today's Mission</h3>
              <p className="mission-subtitle">Complete the rings to earn badges!</p>
            </div>
            
            <div className="rings-container">
              <div className="ring-item">
                <div className="ring-circle" style={{ background: `conic-gradient(#00BFD9 0deg ${(getTodaysHabitCount() / 12) * 360}deg, #E0E0E0 0deg)` }}>
                  <div className="ring-center">
                    <div className="ring-value">{getTodaysHabitCount()}</div>
                    <div className="ring-label">Habits</div>
                  </div>
                </div>
              </div>
<div className="multiplier-display">
              <div className="multiplier-card">
                <div className="multiplier-value">{streak > 0 ? (Math.min(1.0 + (streak - 1) * 0.12, 2.5)).toFixed(2) : '1.00'}x</div>
                <div className="multiplier-label">Streak Multiplier</div>
                <div className="multiplier-desc">Day {streak} of your streak</div>
              </div>
              <div className="multiplier-info">
                <p>🔥 Your daily score is multiplied by your streak!</p>
                <p>Keep logging daily to increase your multiplier up to 2.5x</p>
              </div>
            </div>
              <div className="ring-item">
                <div className="ring-circle" style={{ background: `conic-gradient(#00E5FF 0deg ${(ngiScore / 100) * 360}deg, #E0E0E0 0deg)` }}>
                  <div className="ring-center">
                    <div className="ring-value">{ngiScore}</div>
                    <div className="ring-label">Score</div>
                  </div>
                </div>
              </div>

              <div className="ring-item">
                <div className="ring-circle" style={{ background: `conic-gradient(#FF6B6B 0deg ${(streak / 30) * 360}deg, #E0E0E0 0deg)` }}>
                  <div className="ring-center">
                    <div className="ring-value">{streak}</div>
                    <div className="ring-label">Streak</div>
                  </div>
                </div>
              </div>
            </div>

            {getTodaysHabitCount() >= 5 && (
              <div className="badge-earned-today">
                <p>✨ You've earned badges today! Check your profile.</p>
              </div>
            )}
          </div>

          <div className="lifetime-scorecard-section">
            <div className="scorecard-header">
              <h3>🏆 Your Rank</h3>
            </div>
            <div className="rank-display">
              <div className="rank-info">
                <div className="rank-emoji">{getRank(calculateTotalXP()).emoji}</div>
                <div className="rank-text">
                  <div className="rank-name">{getRank(calculateTotalXP()).name}</div>
                  <div className="rank-xp">{calculateTotalXP()} / {getRankThresholds(calculateTotalXP()).next.max} XP</div>
                </div>
              </div>
              <div className="rank-progress">
                <div className="progress-bar" style={{ width: `${getRankThresholds(calculateTotalXP()).progress}%` }}></div>
              </div>
            </div>

            <div className="lifetime-stats">
              <div className="stat-item">
                <span className="stat-icon">🌟</span>
                <div className="stat-detail">
                  <div className="stat-value">{earnedBadges['Perfect Day'] ? '✓' : '0'}</div>
                  <div className="stat-name">Perfect Days</div>
                </div>
              </div>
              <div className="stat-item">
                <span className="stat-icon">🔥</span>
                <div className="stat-detail">
                  <div className="stat-value">{earnedBadges['Momentum Builder'] ? '✓' : '0'}</div>
                  <div className="stat-name">Momentum Days</div>
                </div>
              </div>
              <div className="stat-item">
                <span className="stat-icon">📊</span>
                <div className="stat-detail">
                  <div className="stat-value">{prayers.length}</div>
                  <div className="stat-name">Days Logged</div>
                </div>
              </div>
            </div>
          </div>
          <div className="quick-nav">
            <button className="quick-nav-btn" onClick={() => setCurrentScreen('prayer')}>🙏 Prayers</button>
            <button className="quick-nav-btn" onClick={() => setCurrentScreen('bible')}>📖 Bible</button>
            <button className="quick-nav-btn" onClick={() => setCurrentScreen('profile')}>👤 Profile</button>
          </div>
        </div>
        <Tutorial currentStep={tutorialStep} onNext={nextTutorialStep} onSkip={completeTutorial} isActive={tutorialActive} />
        <button className="help-button" onClick={startTutorial} title="Restart Tutorial">?</button>
        {showBadgeModal && (
          <div className="badge-modal-overlay" onClick={() => setShowBadgeModal(false)}>
            <div className="badge-modal" onClick={(e) => e.stopPropagation()}>
              <div className="badge-modal-emoji">{badgeCriteria[newBadge]?.emoji}</div>
              <h2>Achievement Unlocked!</h2>
              <p className="badge-modal-name">{newBadge}</p>
              <p className="badge-modal-msg">{badgeCriteria[newBadge]?.desc}</p>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (currentScreen === 'prayer') {
    return (
      <div className="prayer-section">
        <div className="section-header">
          <h2>🙏 Prayer Journal</h2>
          <button className="back-btn" onClick={() => setCurrentScreen('home')}>← Back</button>
        </div>
        <div className="prayer-entry-card">
          <h3>Write Your Prayer</h3>
          <form onSubmit={savePrayer}>
            <textarea className="prayer-textarea" placeholder="What's on your heart today?" value={prayerText} onChange={(e) => setPrayerText(e.target.value)} />
            <div className="mood-selector">
              <label>How are you feeling?</label>
              <div className="mood-options">
                {['Grateful', 'Seeking', 'Joyful', 'Humble', 'Hopeful'].map(mood => (
                  <button key={mood} type="button" className={`mood-btn ${selectedMood === mood ? 'selected' : ''}`} onClick={() => setSelectedMood(mood)}>{mood}</button>
                ))}
              </div>
            </div>
            <button type="submit" className="pb gld">💾 Save Prayer</button>
          </form>
        </div>
        <div className="prayer-history">
          <h3>Your Prayers ({prayers.length})</h3>
          {prayers.length === 0 ? (
            <p style={{ color: '#00768F', textAlign: 'center', padding: '20px' }}>Start praying to see your journal grow</p>
          ) : (
            <div className="prayer-list">
              {prayers.slice().reverse().map((prayer) => (
                <div key={prayer.id} className="prayer-item">
                  <div className="prayer-header">
                    <span className="prayer-mood">{prayer.mood}</span>
                    <span className="prayer-date">{new Date(prayer.created_at).toLocaleDateString()}</span>
                  </div>
                  <p className="prayer-text">{prayer.entry_text}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  if (currentScreen === 'bible') {
    return (
      <div className="bible-section">
        <div className="section-header">
          <h2>📖 Bible Reader</h2>
          <button className="back-btn" onClick={() => setCurrentScreen('home')}>← Back</button>
        </div>
<div className="daily-verse-card">
          <div className="daily-header">
            <h3>📖 Verse of the Day</h3>
          </div>
          <div className="daily-verse-display">
            <p className="daily-ref">{getTodayVerse().ref}</p>
            <p className="daily-text">"{getTodayVerse().text}"</p>
            <div className="daily-devotion">
              <p className="devotion-label">💭 Reflection:</p>
              <p className="devotion-text">{getTodayVerse().devotion}</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '12px' }}>
            <button className="bookmark-btn" onClick={() => openNotesModal(getTodayVerse())}>🔖 Bookmark</button>
          </div>
        </div>      
  <div className="bible-search">
          <input type="text" className="bible-input" placeholder="Search: Genesis 1:1, Matthew 3:3, Exodus 1:1" value={bibleSearch} onChange={(e) => handleBibleSearch(e.target.value)} />
        </div>
        {bibleLoading && <p style={{ color: '#00BFD9', textAlign: 'center', padding: '20px', fontWeight: '700' }}>🔍 Searching...</p>}
        {bibleResults.length > 0 ? (
          <div>
            {bibleResults.map((verse, idx) => (
              <div key={idx} className="featured-verse">
                <div className="verse-display">
                  <p className="verse-text">"{verse.text}"</p>
                  <p className="verse-ref">— {verse.ref}</p>
                </div>
                <button className="bookmark-btn" onClick={() => openNotesModal(verse)}>🔖 Bookmark</button>
              </div>
            ))}
          </div>
        ) : bibleSearch && !bibleLoading ? (
          <p style={{ color: '#00768F', textAlign: 'center', padding: '20px' }}>No verses found. Try: Genesis 1:1, Exodus 1:1, Matthew 3:3</p>
        ) : null}
        <div className="bookmarks-section">
          <h3>📌 Your Bookmarks ({bookmarks.length})</h3>
          {bookmarks.length === 0 ? (
            <p style={{ color: '#00768F', textAlign: 'center', padding: '20px' }}>Bookmark verses to save them</p>
          ) : (
            <div className="bookmarks-list">
              {bookmarks.map((bm, idx) => (
                <div key={idx} className="bookmark-item">
                  <span className="bookmark-ref">{bm.verse_reference}</span>
                  <p className="bookmark-text">"{bm.verse_text}"</p>
                  {bm.notes && (
                    <div className="bookmark-notes">
                      <p className="notes-label">📝 My Note:</p>
                      <p className="notes-text">{bm.notes}</p>
                    </div>
                  )}
                  <div className="bookmark-actions">
                    <button className="btn-edit-notes" onClick={() => editNotes(idx, bm.notes || '')}>✏️ Edit Note</button>
                    <button className="btn-delete-bookmark" onClick={() => deleteBookmark(idx)}>🗑️ Delete</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {showNotesModal && (
          <div className="notes-modal-overlay" onClick={() => setShowNotesModal(false)}>
            <div className="notes-modal" onClick={(e) => e.stopPropagation()}>
              <h3>📝 {editingBookmarkId !== null ? 'Edit' : 'Add'} Personal Note</h3>
              {pendingBookmark && (
                <div className="modal-verse">
                  <p style={{ fontSize: '12px', color: '#00768F', fontWeight: '600' }}>{pendingBookmark.ref}</p>
                  <p style={{ fontSize: '13px', color: '#004D5C', fontStyle: 'italic', marginTop: '4px' }}>"{pendingBookmark.text}"</p>
                </div>
              )}
              <textarea className="notes-textarea" placeholder="What does this verse mean to you? How does it apply to your life?" value={noteText} onChange={(e) => setNoteText(e.target.value)} />
              <div className="modal-buttons">
                <button onClick={() => setShowNotesModal(false)} className="btn-cancel">Cancel</button>
                <button onClick={saveNotes} className="btn-save-notes">Save Note</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (currentScreen === 'profile') {
    return (
      <div className="profile-section">
        <div className="section-header">
          <h2>👤 Your Profile</h2>
          <button className="back-btn" onClick={() => setCurrentScreen('home')}>← Back</button>
        </div>
        <div className="profile-card">
          <div className="profile-avatar">{userName.charAt(0).toUpperCase()}</div>
          <h3>{userName}</h3>
          <p className="profile-email">{email}</p>
          <div className="profile-stats">
            <div className="stat-box">
              <div className="stat-value">{ngiScore}</div>
              <div className="stat-label">NGI Score</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">{streak}</div>
              <div className="stat-label">Streak Days</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">{Object.keys(earnedBadges).length}</div>
              <div className="stat-label">Badges Earned</div>
            </div>
          </div>
        </div>
          <div className="ngi-calculation-section">
            <h3>📊 How Your NGI Score Is Calculated</h3>
            <div className="calculation-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <p className="step-title">Daily Habits</p>
                <p className="step-formula">(Habits Completed Today ÷ 12) × 100 = {dailyNGI}%</p>
              </div>
            </div>
            <div className="calculation-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <p className="step-title">Weekly Consistency</p>
                <p className="step-formula">(Days Logged This Week ÷ 7) × 100 = {weeklyNGI}%</p>
              </div>
            </div>
            <div className="calculation-step">
              <div className="step-number">=</div>
              <div className="step-content">
                <p className="step-title">Overall NGI Score</p>
                <p className="step-formula">({dailyNGI}% + {weeklyNGI}%) ÷ 2 = {lifetimeNGI}%</p>
              </div>
            </div>
            <div className="calculation-privacy-note">
              <p>🔐 Your Privacy: This score is calculated locally on your device. No tracking. No administrators see this. For YOU only.</p>
            </div>
          </div>
        <div className="badges-section">
          <h3>🏆 Your Achievements</h3>
          {Object.keys(earnedBadges).length === 0 ? (
            <p style={{ color: '#00768F', textAlign: 'center', padding: '20px' }}>Keep logging habits to earn badges!</p>
          ) : (
            <div className="badges-grid">
              {Object.keys(earnedBadges).map((badgeName) => (
                <div key={badgeName} className="badge-item">
                  <span className="badge-emoji">{badgeCriteria[badgeName]?.emoji}</span>
                  <p className="badge-name">{badgeName}</p>
                  <p style={{ fontSize: '9px', color: '#00768F', marginTop: '4px' }}>{badgeCriteria[badgeName]?.desc}</p>
                </div>
              ))}
            </div>
          )}
          <div className="available-badges">
            <h4 style={{ marginBottom: '12px', color: '#00BFD9' }}>🎯 Available to Earn:</h4>
            {Object.keys(badgeCriteria).filter(name => !earnedBadges[name]).map((badgeName) => (
              <div key={badgeName} className="available-badge">
                <span className="ab-emoji">{badgeCriteria[badgeName].emoji}</span>
                <div className="ab-info">
                  <div className="ab-name">{badgeName}</div>
                  <div className="ab-desc">{badgeCriteria[badgeName].desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
